import { PulseComponent } from "@pulsex/types";
import dynamic from "next/dynamic";

const groupIdRegistry: Record<string, PulseComponent> = {
    ThreeColumnLayout: {
        Component: dynamic(() => import("@/components/ThreeColumnLayout")),
    },
    TwoColumnLayout: {
        Component: dynamic(() => import("@/components/TwoColumnLayout")),
    },
    TwoCarouselsWithTwoSideTabs: {
        Component: dynamic(
            () => import("@/components/NewsPage/TwoCarouselsWithTwoSideTabs")
        ),
    },
    TwoCarouselsWithTwoSideAd: {
        Component: dynamic(
            () => import("@/components/NewsPage/TwoCarouselsWithTwoSideAd")
        ),
    },
    "VideoTabSlider/Tabs": {
        Component: dynamic(() => import("@/components/HomeVideosSection")),
    },
    PostDetails: {
        Component: dynamic(
            () => import("@/components/DetailsPage/DetailsGroup")
        ),
    },
    carouselsWithSidebar: {
        Component: dynamic(
            () => import("@/components/CarouselsWithSidebarGroup")
        ),
    },
    "Covergae/VideosTabs": {
        Component: dynamic(() => import("@/components/CoverageVideosSection")),
    },
    DigitalSeriesDoubleCarousel: {
        Component: dynamic(() => import("@/components/DigitalSeriesDoubleCarousel")),
    }
};
export default groupIdRegistry;
